import { request, API_BASE } from './http'
import type { Asset, Character } from '@/types/nf'

export interface DesignCharacter { id: string; name: string; appearance: string; draft: string }
export interface DesignPreflight { ready: boolean; missing: string[]; characters: DesignCharacter[] }
export interface DesignCandidatePayload {
  character_id: string
  appearance: string
  seed: number
  views: Record<string, string>
  image_ref?: string
  error?: string
  metadata: { pool_primary?: boolean }
}
const projectPath = (p: string) => `/v1/projects/${encodeURIComponent(p)}`
const designPath = (p: string, c: string) => `${projectPath(p)}/characters/${encodeURIComponent(c)}/design`
const scoped = (path: string, branch: string) => `${path}?branch_id=${encodeURIComponent(branch)}`
const mediaUrl = (path: string) => `${API_BASE}${path}`
export const characterDesignApi = {
  entities: (p: string,b: string) => request<Character[]>(scoped(`${projectPath(p)}/characters`,b)),
  preflight: (p: string, b: string, c?: string) => request<DesignPreflight>(scoped(c ? `${designPath(p,c)}/preflight` : `${projectPath(p)}/character-design/preflight`,b)),
  save: (p: string,b: string,c: string,appearance: string) => request<{appearance: string}>(scoped(`${designPath(p,c)}/appearance`,b),{method:'PUT',body:{appearance}}),
  suggest: (p: string,b: string,c: string) => request<{appearance: string}>(scoped(`${designPath(p,c)}/suggest`,b),{method:'POST',body:{}}),
  draw: (p: string,b: string,c: string,replay?: string) => request<{asset_id: string}>(scoped(designPath(p,c),b),{method:'POST',body:replay ? {replay_asset_id:replay} : {}}),
  candidates: (p: string,b: string,c: string) => request<Asset[]>(scoped(`${designPath(p,c)}/candidates`,b)),
  lock: (p: string,b: string,c: string,id: string) => request<Asset>(scoped(`${designPath(p,c)}/candidates/${encodeURIComponent(id)}/lock`,b),{method:'POST',body:{}}),
  discard: (p: string,b: string,c: string,id: string) => request<void>(scoped(`${designPath(p,c)}/candidates/${encodeURIComponent(id)}`,b),{method:'DELETE'}),
  image: (p: string,b: string,c: string,id: string,view?: string) => mediaUrl(scoped(`${designPath(p,c)}/candidates/${encodeURIComponent(id)}/image`,b)+(view ? `&view=${encodeURIComponent(view)}` : '')),
  classify: (p: string,b: string) => request(scoped(`${projectPath(p)}/character-design/classify`,b),{method:'POST',body:{}}),
  changeKind: (p: string,b: string,c: string,role_type: string) => request(scoped(`${projectPath(p)}/characters/${encodeURIComponent(c)}`,b),{method:'PATCH',body:{role_type}}),
}

export function designCandidatePayload(asset: Asset): DesignCandidatePayload {
  return typeof asset.payload === 'string' ? JSON.parse(asset.payload) as DesignCandidatePayload : asset.payload as unknown as DesignCandidatePayload
}
